import React from "react";
import { VstButton } from "vstui";

export default class Confidences extends React.Component {
  constructor() {
    super();
    this.state = {
      showStats: false,
      statsPosition: "bottom"
    };

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this._countConfidences = this._countConfidences.bind(this);
  }

  show() {
    const statsButton = document.getElementById(
      `show-stats-${this.props.deckUuid}`
    );
    const statsPosition =
      window.innerHeight > statsButton.getBoundingClientRect().bottom + 140
        ? "bottom"
        : "top";
    this.setState({
      showStats: true,
      statsPosition
    });
  }

  hide() {
    this.setState({ showStats: false });
  }

  _countConfidences() {
    let high = 0,
      medium = 0,
      low = 0;
    this.props.confidences.forEach(confidence => {
      if (confidence.level > 75) {
        high += 1;
      } else if (confidence.level > 25) {
        medium += 1;
      } else {
        low += 1;
      }
    });
    medium += this.props.unrated;
    return { low, medium, high };
  }

  _paths(low, medium, high) {
    let paths;
    let offset = 0.015;
    const total = low + medium + high;
    if (low) {
      if (medium && high) {
        low *= 1 - offset * 2;
        medium *= 1 - offset * 2;
        high *= 1 - offset * 2;
      } else if (medium) {
        low *= 1 - offset;
        medium *= 1 - offset;
      } else if (high) {
        low *= 1 - offset;
        high *= 1 - offset;
      } else {
        offset = 0;
      }
    } else if (medium) {
      if (high) {
        medium *= 1 - offset;
        high *= 1 - offset;
      } else {
        offset = 0;
      }
    }
    const slices = [
      { percent: low / total, color: "#ED6856", key: "low" },
      { percent: offset, color: "#FFFFFF", key: "offset-1" },
      { percent: medium / total, color: "#B3B3B3", key: "medium" },
      { percent: offset, color: "#FFFFFF", key: "offset-2" },
      { percent: high / total - offset * !!high, color: "#67BE6C", key: "high" }
    ];
    let cumulativePercentage = 0;
    paths = slices.reduce((acc, slice) => {
      const startX = Math.cos(2 * Math.PI * cumulativePercentage);
      const startY = Math.sin(2 * Math.PI * cumulativePercentage);

      cumulativePercentage += slice.percent;
      const endX = Math.cos(2 * Math.PI * cumulativePercentage);
      const endY = Math.sin(2 * Math.PI * cumulativePercentage);

      const largeArcFlag = slice.percent > 0.5 ? 1 : 0;

      const pathData = [
        `M ${startX} ${startY}`, // Move
        `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
        `L 0 0` // Line
      ].join(" ");

      acc.push(
        <path key={`slice-${slice.key}`} d={pathData} fill={slice.color} />
      );
      return acc;
    }, []);
    return paths;
  }

  render() {
    const { low, medium, high } = this._countConfidences();
    if (low + high === 0) {
      return null;
    }
    return (
      <VstButton
        ref={el => {
          this.statsButton = el;
        }}
        id={`show-stats-${this.props.deckUuid}`}
        className="proficiencies noButton"
        role="presentation"
        onBlur={this.hide}
        onFocus={this.show}
        onMouseOver={this.show}
        onMouseLeave={this.hide}
      >
        <svg viewBox="-1 -1 2 2" style={{ transform: "rotate(-90deg)" }}>
          {this._paths(low, medium, high)}
        </svg>
        <span className="offScreen">
          {i18n.t("reader.flashcards.deck-proficiencies")}
        </span>
        <div className="center" />
        <div
          ref={el => {
            this.statsEl = el;
          }}
          className={`stats ${this.state.showStats ? "on" : "off"} ${
            this.state.statsPosition
          }`}
          role="tooltip"
          aria-describedby={`${
            this.state.showStats ? "show-stats-" + this.props.deckUuid : ""
          }`}
        >
          <div className="line">
            <div className="count high">{high}</div>
            <span className="label">{i18n.t("reader.flashcards.correct")}</span>
          </div>
          <div className="line">
            <span className="count medium">{medium}</span>
            <span className="label">
              {i18n.t("reader.flashcards.unanswered")}
            </span>
          </div>
          <div className="line">
            <span className="count low">{low}</span>
            <span className="label">{i18n.t("reader.flashcards.wrong")}</span>
          </div>
        </div>
      </VstButton>
    );
  }
}

Confidences.defaultProps = {
  confidences: []
};
